import { topicCollections } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按题材分类探索漫画世界，点击进入你感兴趣的专题，发现更多精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topicCollections.slice(0, 4).map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer border border-background-200/60"
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${
                  item.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : item.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {topicCollections.slice(4).map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer border border-background-200/60"
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${
                  item.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : item.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}